/**
 * Dynamically Set Search bar top position
 */

window.addEventListener('load', function () {
  // Global varaibles
  var searchContainer = document.querySelector('#doc-search-container'),
    searchOverlay = document.querySelector('#doc-search-overlay'),
    searchMenuIcon = document.querySelectorAll('.doc-menu-toggle'),
    primaryHeader = document.querySelector('#header-habitat'),
    promoClose = document.querySelector('.accept-promo-notification-cross'),
    promoCta = document.querySelectorAll('.promo-notification a'),
    secondaryHeader = document.querySelector('#secondary-nav'),
    searchBarOffsetTop;

  // if clicked on search icon in header.
  if (searchMenuIcon) {
    for (i = 0; i < searchMenuIcon.length; i++) {
      searchMenuIcon[i].addEventListener('click', setSearchTopPosition);
    }
  }

  // if clicked on close icon of promobar above the header.
  if (promoClose) {
    promoClose.addEventListener('click', setSearchTopPosition);
  }

  // if clicked on cta present in the promobar above the header.
  if (promoCta) {
    for (i = 0; i < promoCta.length; i++) {
      promoCta[i].addEventListener('click', setSearchTopPosition);
    }
  }

  /**
   * Set the searchbar top position
   * @param {*} e
   */
  function setSearchTopPosition() {
    searchBarOffsetTop = getSearchTopPosition();

    // get the document scroll position.
    var docScroll = document.documentElement.scrollTop;

    // Check if sec headeris present and based on that add the height.
    if (docScroll > 0 && docScroll < searchBarOffsetTop + (secondaryHeader ? secondaryHeader.offsetHeight : 0)) {
      searchContainer.style.top = searchBarOffsetTop + primaryHeader.offsetHeight - docScroll + 'px';
      searchOverlay.style.top = searchBarOffsetTop + primaryHeader.offsetHeight - docScroll + 'px';
    } else {
      searchContainer.style.top = searchBarOffsetTop + primaryHeader.offsetHeight + 'px';
      searchOverlay.style.top = searchBarOffsetTop + primaryHeader.offsetHeight + 'px';
    }
  }

  /**
   * Get the searchbar top position based on primary header
   */
  function getSearchTopPosition() {
    return primaryHeader.offsetTop;
  }
});
